import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPt1Bg } from './pages'

type TIdToPageMapWoofzPt1Bg = Record<PageIdWoofzPt1Bg, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PT1_BG: TIdToPageMapWoofzPt1Bg = {
  [PageIdWoofzPt1Bg.DOG_SEX_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzPt1Bg.DOG_AGE_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.DogAgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzPt1Bg.SHELTER_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/DogShelterQuestion'
      ).then((m) => ({
        default: m.DogShelterQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogShelterQuestion'),
  },
  [PageIdWoofzPt1Bg.DOG_BREED_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzPt1Bg.URGE_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/urge/UrgePagePT').then((m) => ({
        default: m.UrgePagePT,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1_bg/pages/urge/UrgePagePT'),
  },
  [PageIdWoofzPt1Bg.STARTED_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/StartedPTQuestion'
      ).then((m) => ({
        default: m.StartedPTQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/StartedPTQuestion'),
  },
  [PageIdWoofzPt1Bg.PLACE_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/PottyPlaceQuestion'
      ).then((m) => ({
        default: m.PlacePTQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/PottyPlaceQuestion'),
  },
  [PageIdWoofzPt1Bg.GOALS_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/GoalsQuestion').then(
        (m) => ({
          default: m.GoalsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/GoalsQuestion'),
  },
  [PageIdWoofzPt1Bg.ACCIDENTS_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/DogAccidentsQuestion'
      ).then((m) => ({
        default: m.DogAccidentsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogAccidentsQuestion'),
  },
  [PageIdWoofzPt1Bg.CONCERNS_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/ConcernsQuestion'
      ).then((m) => ({
        default: m.ConcernsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/ConcernsQuestion'),
  },
  [PageIdWoofzPt1Bg.URGE_2_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/urge/UrgePagePTVariant2').then(
        (m) => ({
          default: m.UrgePagePT2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/urge/UrgePagePTVariant2'),
  },
  [PageIdWoofzPt1Bg.LIVING_SITUATION_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/LivingSituationQuestion'
      ).then((m) => ({
        default: m.LivingSituationQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/LivingSituationQuestion'
      ),
  },
  [PageIdWoofzPt1Bg.POTTY_BREAKS_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/OutsidePottyBreaksQuestion'
      ).then((m) => ({
        default: m.PottyBreaksQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/OutsidePottyBreaksQuestion'
      ),
  },
  [PageIdWoofzPt1Bg.CRATE_TRAINING_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/CrateTrainingQuestion'
      ).then((m) => ({
        default: m.CrateTrainingQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/CrateTrainingQuestion'
      ),
  },
  [PageIdWoofzPt1Bg.COMMANDS_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/DogCommands'),
  },
  [PageIdWoofzPt1Bg.TRAINING_TIME_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/questions/TrainingTimeQuestion'
      ).then((m) => ({
        default: m.TrainingTimeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/questions/TrainingTimeQuestion'),
  },
  [PageIdWoofzPt1Bg.PREPARE_FLOW_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdWoofzPt1Bg.COMMITMENT_SCREEN_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/urge/WoofzCommitment').then(
        (m) => ({
          default: m.WoofzCommitment,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/urge/WoofzCommitment'),
  },
  [PageIdWoofzPt1Bg.EMAIL_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/email/EmailVariantPT').then(
        (m) => ({
          default: m.EmailVariantPT,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/email/EmailVariantPT'),
  },
  [PageIdWoofzPt1Bg.NEWSLETTER_URGE_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPt1Bg.SUBSCRIPTIONS_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/subscriptions/SubscriptionsPage'
      ),
  },
  [PageIdWoofzPt1Bg.CANCEL_OFFER_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/subscriptions/CancelOfferVariantPT'
      ).then((m) => ({
        default: m.CancelOfferVariantPT,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/subscriptions/CancelOfferVariantPT'
      ),
  },
  [PageIdWoofzPt1Bg.CHAT_UPSELL_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPt1Bg.UPSELL_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pt1_bg/pages/upsell/Upsell'),
  },
  [PageIdWoofzPt1Bg.UPSELL_FEEDING_GUIDE_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPt1Bg.UPSELL_EMOTIONAL_SUPPORT_PT1_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pt1_bg/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPt1Bg.DOWNLOAD_PT1_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pt1_bg/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pt1_bg/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPt1Bg.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
